import DOMService from '@services/DOMService';
import linkifyHtml from 'linkify-html';

// This component will overwrite a string in case there is found a phone number, email address, URL, or ...
// Linkify and its related packages to detect URLs, email addresses and more in plain-text strings and convert them to HTML <a> anchor tags.
export function purifyAndLinkifyText(text: string): string {
  const purifiedText = DOMService.purify(text);
  const linkifyOptions = {
    defaultProtocol: 'https',
    target: '_blank',
  };

  return linkifyHtml(purifiedText, linkifyOptions);
}
